import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { generateDalalePDF, generateDalaleListPDF } from '../services/pdfService';
import PageHero from '../components/common/PageHero';
import Button from '../components/common/Button';
import Card from '../components/common/Card';
import Table from '../components/common/Table';
import { formatDate, downloadCsvFile, toMoney } from '../utils/helpers';
import toast from 'react-hot-toast';

const formatCommission = (value) => {
  const n = toMoney(value);
  return `${n}%`;
};

const Dalale = () => {
  const navigate = useNavigate();
  const { dalale, loadingDalale } = useApp();

  const exportCsv = () => {
    if (!dalale.length) {
      toast.error('Dalale ma jiraan');
      return;
    }
    const headers = [
      'ID',
      'Magaca',
      'Telefoon',
      'Degmo',
      'Commission (%)',
      'La sameeyay',
      'La cusbooneysiiyay'
    ];
    const rows = dalale.map((d) => [
      d.id,
      d.name,
      d.phone,
      d.degmo,
      toMoney(d.commissionPercent),
      formatDate(d.createdAt),
      formatDate(d.updatedAt)
    ]);
    const stamp = new Date().toISOString().slice(0, 10);
    downloadCsvFile(`dalale-all-${stamp}.csv`, headers, rows);
    toast.success(`CSV: ${dalale.length} dalale`);
  };

  const exportPdfAll = async () => {
    try {
      await generateDalaleListPDF(dalale);
      toast.success('PDF waa la soo dejiyay');
    } catch {
      toast.error('PDF khalad');
    }
  };

  const downloadOnePdf = async (e, row) => {
    e.stopPropagation();
    try {
      await generateDalalePDF(row);
      toast.success('PDF waa la soo dejiyay');
    } catch {
      toast.error('PDF khalad');
    }
  };

  const columns = [
    {
      key: 'name',
      label: 'Magaca',
      render: (v) => <span className="font-semibold text-gray-900">{v}</span>
    },
    { key: 'phone', label: 'Telefoon' },
    { key: 'degmo', label: 'Degmo', render: (v) => v || '—' },
    {
      key: 'commissionPercent',
      label: 'Commission',
      render: (v) => <span className="font-medium text-blue-700">{formatCommission(v)}</span>
    },
    {
      key: 'updatedAt',
      label: 'Cusbooneysi',
      render: (v) => formatDate(v)
    },
    {
      key: 'actions',
      label: '',
      render: (_, row) => (
        <Button type="button" variant="outline" className="!py-1 !px-2 text-xs" onClick={(e) => downloadOnePdf(e, row)}>
          PDF
        </Button>
      )
    }
  ];

  return (
    <div className="space-y-6">
      <PageHero
        title="Dalale"
        subtitle="Diiwaanka dalale — magac, telefoon, degmo, commission"
        actions={
          <div className="flex flex-wrap gap-2">
            <Button variant="secondary" onClick={exportCsv} icon={<span>📥</span>}>
              CSV (dhammaan)
            </Button>
            <Button variant="secondary" onClick={exportPdfAll} icon={<span>📄</span>}>
              PDF (dhammaan)
            </Button>
            <Button onClick={() => navigate('/admin/dalale/new')}>+ Dalale cusub</Button>
          </div>
        }
      />
      <Card>
        <Table
          columns={columns}
          data={dalale}
          loading={loadingDalale}
          emptyMessage="Dalale lama diiwaangelin"
          onRowClick={(row) => navigate(`/admin/dalale/${row.id}`)}
        />
      </Card>
    </div>
  );
};

export default Dalale;
